export default __webpack_public_path__ + "images/64cb64e93b78c55653951505d085c467.svg";